// reducer for modal

import { createSlice } from '@reduxjs/toolkit';

export interface IModalData {
  open: boolean;
}

export interface IModalState {
  modals: {
    [key: string]: IModalData;
  };
}

const initialState = {
  modals: {},
} as IModalState;

const modalData = createSlice({
  name: 'modal',
  initialState: initialState,
  reducers: {
    openModal: (state, action) => {
      const { modalId } = action.payload;
      state.modals[modalId] = {
        open: true,
      };
    },
    closeModal: (state, action) => {
      const { modalId } = action.payload;
      state.modals[modalId] = {
        open: false,
      };
    },
  },
});

export const modalActions = modalData.actions;
export default modalData.reducer;
